// --- Modules
import Node, { payload } from './Node';

class Host extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Host'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Host(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
